const isNumber = (data) => {
  
  let name = data.config.validationName;
  let value = data.value;
  value = value.trim();
  return (!isNaN(value)) ? true : "Please enter a valid "+ name;
}

export default isNumber;
